import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { OptionsBoardComponent } from '@shared/components/trading/options-board/options-board.component'
import { OptionsBoardSettingsInterface } from '@shared/components/trading/widgets/options-board-widget/core/interfaces/options-board-settings.interface'

@Component({
	selector: 'app-options-board-widget',
	templateUrl: './options-board-widget.component.html',
	styleUrl: './options-board-widget.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [OptionsBoardComponent],
})
export class OptionsBoardWidgetComponent {
	public widget: InputSignal<WidgetInterface<OptionsBoardSettingsInterface> | null> =
		input<WidgetInterface<OptionsBoardSettingsInterface> | null>(null)
}
